import apiUseCases from "@src/cloud-connect/api";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { i18n } from "@src/i18n/i18n";
import store from "@src/reducers/store";

export const getBlueprintsLibraryUseCase = async () => {
  const language = store.getState().yourSlice.language;
  const namespace = store.getState().yourSlice.authContext.customerNamespace;
  const data = await apiUseCases.getMyBlueprintLibrary(namespace);
  const texts = {
    blueprintLibraryUnexpectedError: i18n(
      "modules.snackbarNotifications.blueprintLibraryUnexpectedError",
      language,
    ),
  };
  if (data.status === 200) {
    return data.body;
  } else {
    errorSnackbar(texts.blueprintLibraryUnexpectedError);
    return [];
  }
};
